// Full-document render of the Oscar account-login view: PageSkeleton (the React
// document shell) wrapping the account-page layout -- the brand heading, the
// LoginStandalone form island, the decorative account image, and the
// customer-service info block. The brand heading + section heading + decorative
// image arrive pre-resolved as props (server-side gettext + per-APP_SLUG
// branding); the customer-service block travels as the `cs_info_json` seam.
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as LoginStandalone } from "./LoginStandaloneTemplate";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {/* React 19 hoists this meta into <head>; the description meta
                renders from page_chrome.search_description. */}
            <meta name="chatTags" content="login" />
            <div className="l-capped-width">
                <div className="account-page-title">
                    <h1>{props.page_copy?.page_heading}</h1>
                </div>

                <section className="account-page-container">
                    <div>
                        <h2>{props.page_copy?.section_heading}</h2>
                        <LoginStandalone {...props.login_standalone} />
                    </div>
                    <div>
                        {props.page_copy?.account_image ? (
                            <img
                                src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                                alt={props.page_copy.account_image_alt}
                            />
                        ) : null}
                    </div>
                </section>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
